module.exports = __webpack_public_path__ + "static/media/nodejs.abecfc00.png";